export default __webpack_public_path__ + "static/media/GerrieLovelace.c3595437.png";